import OnBoardingContainer from '../../../components/on-boarding';
import { SelectForm } from './SelectForm';
import { useOnBoardingStep4 } from '../hooks/useOnBoardingStep4';
// import InputForm from './InputForm';
import { Form } from '@/components/ui/form';

export default function OnBoardingStep4() {
  const { response, handleSubmit, form } = useOnBoardingStep4();

  const renderContent = () => {
    return (
      <Form {...form}>
        <form className="mb-8 mt-4 flex flex-col justify-center gap-[20px] md:max-w-[358px]">
          <SelectForm
            label={response?.gender?.label}
            placeholder={response?.gender?.placeholder}
            options={response?.gender?.options?.map((option) => option!.option!)}
            onClickOption={form.setValue}
            control={form.control}
            name="gender"
          />
          <SelectForm
            label={response?.role?.label}
            placeholder={response?.role?.placeholder}
            options={response?.roles?.map((role) => role!.role!)}
            onClickOption={form.setValue}
            control={form.control}
            name="role"
          />
          <SelectForm
            label={response?.ageBracket?.label}
            placeholder={response?.ageBracket?.placeholder}
            options={response?.ageBracket?.options?.map((option) => option!.option!)}
            onClickOption={form.setValue}
            control={form.control}
            name="ageBracket"
          />
          {/* <InputForm
            label={response?.location?.label || ''}
            placeholder={response?.location?.placeholder || ''}
            setValue={form.setValue}
            watch={form.watch}
            name="location"
          /> */}
        </form>
      </Form>
    );
  };

  return (
    <OnBoardingContainer
      step={3}
      image={response.content?.image?.data?.attributes?.url || ''}
      title={response?.content?.title || ''}
      content={renderContent()}
      button={{
        text: response?.content?.button?.text || '',
        onClick: handleSubmit,
      }}
    />
  );
}
